<template>
  <div class="trajectSelector">
    <v-container fluid>
      <p>Type traject*</p>
      <v-select
        v-model="selectedTraject"
        :items="trajectItems"
        item-text="description"
        item-value="id"    
        outlined
        required
        v-on:change="selected"
      ></v-select>
    </v-container>
  </div>
</template>

<script>
    /* eslint-disable */
    import { services } from "../_services";
    import { mapActions } from "vuex";

    export default {
        created: function () {
            services.fetchProcedures().then(
                (data) => {
                    this.trajectItems = this.trajectItems.concat(data);
                },
                (error) => {
                    this.showAlert(error);
                }
            );
        },
        data: function () {
            return {
                selectedTraject: {
                    id: 0,
                    description: "--Selecteer het gewenste traject--",
                },
                trajectItems: [
                    {
                        id: 0,
                        description: "--Selecteer het gewenste traject--",
                        disabled: true,
                    },
                ],
            };
        },
        methods: {
            ...mapActions({
                clearAlert: "alert/clear",
                showAlert: "alert/error",
                selectComp: "appBar/selectComp",
                updateFormModel: "appBar/updateFormModel",
            }),
            selected(trajectId) {
                let $this = this;

                if (trajectId == null || trajectId == 0) {
                    this.updateFormModel({
                        formModel: {
                            id: 1,
                            title: "",
                            selected: false
                        },
                        callback: function () {
                            $this.selectComp({
                                id: 1,
                                type: "select",
                                resetData: false,
                                emptySelection: true,
                            });
                        },
                    });
                    return;
                }

                this.updateFormModel({
                    formModel: {
                        id: 0,
                        title: this.trajectItems.find((x) => x.id == trajectId).description,
                        trajectId: trajectId,
                        selected: true,
                    },
                    callback: function () {
                        $this.selectComp({
                            id: 0,
                            type: "select",
                            resetData: false,
                            emptySelection: false,
                        });
                    },
                });
            },
        },
    };
</script>